
import GbSkeletonLoading from '../../../../components/SkeletonLoading/SkeletonLoading.vue'

export default {
  name: 'EventCardSkeleton',
  components: { GbSkeletonLoading }
}
